import { create } from 'zustand';

const useAppStore = create((set) => ({
    // Tracks whether the sidebar was temporarily expanded from its collapsed
    // (icon-only) state via a submenu trigger click.  When true, the next
    // route change will auto-collapse the sidebar back to icon state.
    sidebarExpandedFromCollapsed: false,
    setSidebarExpandedFromCollapsed: (value) =>
        set({ sidebarExpandedFromCollapsed: value }),
}));

export default useAppStore;
